import React from 'react';

import { TableCell } from '@crossnokaye/ux-common';

import { PRIVILEGES } from '@/hooks/access/access-table';
import { useActionPermission } from '@/hooks/use-action-permission';
import { withTooltip } from '@/ux-common/components/tooltip/with-tooltip';

const TableCellWithTooltip = withTooltip(TableCell);

type DefrostTableCellProps = {
  children: (disabledByPermissions: boolean) => React.ReactNode;
};

export const DefrostTableCell = ({ children }: DefrostTableCellProps) => {
  const { isDisabled, tooltipText } = useActionPermission({
    privilege: PRIVILEGES.writeCommands,
  });

  // bare cell when allowed — empty withTooltip root races nested icon tooltips;
  // remounts if permission flips mid-session (rare). Always-mounted HOC if that bites.
  if (!isDisabled) {
    return <TableCell>{children(false)}</TableCell>;
  }

  return (
    <TableCellWithTooltip tooltipArrow tooltipContent={tooltipText}>
      {children(true)}
    </TableCellWithTooltip>
  );
};
